module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"default_placeholder":"Поиск по энциклопедии...","placeholder":"Поиск по энциклопедии из {total}","perfumes":"Ароматы","brands":"Бренды","content":"В тексте","no_results":"Ничего не найдено"}}')
  delete Component.options._Ctor
}
